import React, { useState } from 'react';
import RenderRevisionNodes from '../../../../Documents/components/RenderRevisionNodes';
import DocumentHeader from '../../../../Documents/components/DocumentHeader';

/**
 * PastePositionSelector Component
 * Allows user to select where to paste the copied node
 * Shows "Paste Above" and "Paste Below" buttons
 */
const PastePositionSelector = ({
  sourceNode,
  targetDocument,
  targetData,
  onPositionSelected,
  onCancel
}) => {
  const [selectedNodeId, setSelectedNodeId] = useState(null);
  const [selectedNodeType, setSelectedNodeType] = useState(null);
  const [checkboxState, setCheckboxState] = useState({});

  const handleNodeCheckbox = (nodeId, nodeType) => {
    // Toggle checkbox and set as selected node
    const newState = { [nodeId]: true };
    setCheckboxState(newState);
    setSelectedNodeId(nodeId);
    setSelectedNodeType(nodeType);
  };

  const getCheckboxState = () => {
    return checkboxState;
  };

  const handlePasteAbove = () => {
    if (selectedNodeId) {
      onPositionSelected('up', selectedNodeType, selectedNodeId);
    }
  };

  const handlePasteBelow = () => {
    if (selectedNodeId) {
      onPositionSelected('below', selectedNodeType, selectedNodeId);
    }
  };

  const handlePasteInto = () => {
    if (selectedNodeId) {
      onPositionSelected('into', selectedNodeType, selectedNodeId);
    }
  };

  return (
    <div>
      {/* AppBar */}
      <header className="appbar">
        <button
          className="appbar-button-secondary"
          onClick={onCancel}
          style={{
            backgroundColor: "#f1f3f4",
            color: "#47515c",
            border: "none",
            padding: "8px 12px",
            cursor: "pointer",
            borderRadius: "4px",
            marginLeft: "15px",
          }}
        >
          Cancel
        </button>

        <h2 style={{ fontSize: "20px", color: "#0D6EFD", position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
          Select Where to Copy To
        </h2>

        <div className="appbar-buttons" style={{ display: 'flex', gap: '10px' }}>
          <button 
            className="appbar-button-secondary" 
            onClick={handlePasteAbove}
            disabled={!selectedNodeId}
            style={{
              backgroundColor: selectedNodeId ? "#fff" : "#f1f3f4",
              color: selectedNodeId ? "#0D6EFD" : "#999",
              border: selectedNodeId ? "1px solid #0D6EFD" : "1px solid #ccc",
              padding: "8px 16px",
              cursor: selectedNodeId ? "pointer" : "not-allowed",
              borderRadius: "4px",
            }}
          >
            Paste Above
          </button>
          <button 
            className="appbar-button-secondary" 
            onClick={handlePasteBelow}
            disabled={!selectedNodeId}
            style={{
              backgroundColor: selectedNodeId ? "#fff" : "#f1f3f4",
              color: selectedNodeId ? "#0D6EFD" : "#999",
              border: selectedNodeId ? "1px solid #0D6EFD" : "1px solid #ccc",
              padding: "8px 16px",
              cursor: selectedNodeId ? "pointer" : "not-allowed",
              borderRadius: "4px",
            }}
          >
            Paste Below
          </button>
        </div>
      </header>

      {/* Document Header */}
      {targetDocument && (
        <DocumentHeader
          type={targetDocument.type}
          partNumber={targetDocument.partNumber}
          revision={targetDocument.revision}
          revisionId={targetDocument.revisionId}
          partId={targetDocument.partId}
          description={false}
          status={targetDocument.status}
          currentRevision={null}
          showCheckbox={false}
          showVersionInfo={false}
          isCheckboxEnabled={false}
        />
      )}

      {/* Target Document Preview */}
      <div style={{ padding: '20px' }}>
        <p style={{ marginBottom: '20px', color: '#666', fontSize: '14px' }}>
          Select a step by clicking its checkbox, then choose "Paste Above" or "Paste Below"
        </p>
        
        <RenderRevisionNodes
          partRef={targetDocument.partId}
          procedureRevRef={targetDocument.revisionId}
          partNumber={targetDocument.partNumber}
          revision={targetDocument.revision}
          disabled={false}
          showCheckbox={true}
          preloadedData={targetData}
          customOnNavigate={handleNodeCheckbox}
          checkboxLabelColor="rgb(0, 102, 204)"
          checkboxState={getCheckboxState()}
          showSectionCheckbox={true}
          hideChildCheckboxes={true}
          hideSubstepCheckboxes={sourceNode?.nodeType === 'step'}
        />
      </div>
    </div>
  );
};

export default PastePositionSelector;
